// src/Cards.js
import React from 'react';
import { useLanguage } from './LanguageContext';
import dis from './photos/dental-cleaning.png';
import implant from './photos/dental-crown.png';
import Kanal from './photos/tooth.png';
import dolgu from './photos/drilling.png';
import orto from './photos/braces.png';
import gulus from './photos/smile.png';
import cene from './photos/dental-surgery.png';
import botoks from './photos/broken.png';
import './Cards.css';  // Import the CSS file for styling

function Cards() {
  const { language, translations } = useLanguage(); // Access language and translations

  return (
    <div className="cards-container">
      <div className="card">
        <div className="icon">
          <img src={dis} alt="Icon 1" />
        </div>
        <div className="card-text">{translations[language].teethCleaning}</div>
        <div className="line"></div>
        <div className="card-description">{translations[language].teethCleaningDesc}</div>
      </div>

      <div className="card">
        <div className="icon">
          <img src={implant} alt="Icon 2" />
        </div>
        <div className="card-text">{translations[language].implant}</div>
        <div className="line"></div>
        <div className="card-description">{translations[language].implantDesc}</div>
      </div>

      <div className="card">
        <div className="icon">
          <img src={Kanal} alt="Icon 3" />
        </div>
        <div className="card-text">{translations[language].canalTreatment}</div>
        <div className="line"></div>
        <div className="card-description">{translations[language].canalTreatmentDesc}</div>
      </div>

      <div className="card">
        <div className="icon">
          <img src={dolgu} alt="Icon 4" />
        </div>
        <div className="card-text">{translations[language].filling}</div>
        <div className="line"></div>
        <div className="card-description">{translations[language].fillingDesc}</div>
      </div>

      <div className="card">
        <div className="icon">
          <img src={orto} alt="Icon 5" />
        </div>
        <div className="card-text">{translations[language].orthodonticTreatment}</div>
        <div className="line"></div>
        <div className="card-description">{translations[language].orthodonticTreatmentDesc}</div>
      </div>

      <div className="card">
        <div className="icon">
          <img src={gulus} alt="Icon 6" />
        </div>
        <div className="card-text">{translations[language].smileDesign}</div>
        <div className="line"></div>
        <div className="card-description">{translations[language].smileDesignDesc}</div>
      </div>

      <div className="card">
        <div className="icon">
          <img src={cene} alt="Icon 7" />
        </div>
        <div className="card-text">{translations[language].jawSurgery}</div>
        <div className="line"></div>
        <div className="card-description">{translations[language].jawSurgeryDesc}</div>
      </div>

      <div className="card">
        <div className="icon">
          <img src={botoks} alt="Icon 8" />
        </div>
        <div className="card-text">{translations[language].bot}</div>
        <div className="line"></div>
        <div className="card-description">{translations[language].botDesc}</div>
      </div>
    </div>
  );
}

export default Cards;
